import React, { useEffect } from "react";
// import AOS from "aos";
// import "aos/dist/aos.css";

const TermsAndConditions = () => {
  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="bg-gray-50 min-h-screen mt-20 px-5 py-10">
      <section id="refund-policy" className="refund-policy">
        <div className="container mx-auto">
          <div className="text-center" data-aos="fade-up">
            <h2 className="text-4xl font-bold mb-5">
              General Terms and Conditions (GTAC)
            </h2>
            <p className="text-gray-600">Last Updated: 17.09.2024 (v1.0)</p>
          </div>

          <div className="mt-10">
            <p className="mb-5">
              Welcome to Cruze, your go-to platform for seamless travel
              experiences and ticket booking services. This privacy policy
              explains how we collect, use, disclose, and safeguard your
              information when you use our services, including cab booking,
              ticketing through Cruze, and any future services we may offer.
            </p>

            <ol className="list-decimal list-inside space-y-8">
              {/* Information We Collect */}
              <li>
                <h3 className="text-2xl font-semibold">
                  Information We Collect
                </h3>
                <p className="mt-2">
                  We collect the following types of information:
                </p>
                <ul className="list-disc list-inside pl-4">
                  <li>
                    <strong>Personal Information:</strong> Your name, contact
                    information, payment details, and preferences.
                  </li>
                  <li>
                    <strong>Usage and Device Information:</strong> Device
                    details, IP addresses, and usage patterns.
                  </li>
                </ul>
              </li>

              {/* How We Use Your Information */}
              <li>
                <h3 className="text-2xl font-semibold">
                  How We Use Your Information
                </h3>
                <p className="mt-2">We use the collected information for:</p>
                <ul className="list-disc list-inside pl-4">
                  <li>
                    <strong>Providing Services:</strong> To facilitate cab
                    bookings, ticket purchases, and related services.
                  </li>
                  <li>
                    <strong>Personalization:</strong> To customize your
                    experience and enhance our services.
                  </li>
                  <li>
                    <strong>Communication:</strong> To send service updates,
                    promotions, and important notices.
                  </li>
                </ul>
              </li>

              {/* Information Sharing */}
              <li>
                <h3 className="text-2xl font-semibold">Information Sharing</h3>
                <p className="mt-2">We may share your information with:</p>
                <ul className="list-disc list-inside pl-4">
                  <li>
                    <strong>Service Providers:</strong> Payment processors,
                    customer support, and technical services.
                  </li>
                  <li>
                    <strong>Business Partners:</strong> For joint promotions or
                    legal compliance.
                  </li>
                </ul>
              </li>

              {/* Your Choices and Rights */}
              <li>
                <h3 className="text-2xl font-semibold">
                  Your Choices and Rights
                </h3>
                <p className="mt-2">You have the following rights:</p>
                <ul className="list-disc list-inside pl-4">
                  <li>Access, update, or delete your information.</li>
                  <li>Opt-out of receiving marketing communications.</li>
                  <li>Disable cookies through your browser settings.</li>
                </ul>
              </li>

              {/* Security of Your Information */}
              <li>
                <h3 className="text-2xl font-semibold">
                  Security of Your Information
                </h3>
                <p className="mt-2">
                  We implement measures to protect your data from unauthorized
                  access and ensure accuracy.
                </p>
              </li>

              {/* Policy Updates */}
              <li>
                <h3 className="text-2xl font-semibold">Policy Updates</h3>
                <p className="mt-2">
                  We may update this privacy policy from time to time. Any
                  changes will be posted on our website, and you will be
                  notified.
                </p>
              </li>

              {/* Contact Us */}
              <li>
                <h3 className="text-2xl font-semibold">Contact Us</h3>
                <p className="mt-2">
                  For questions or concerns, reach out to us at{" "}
                  <a
                    href="mailto:admin@cruze.asia"
                    className="text-blue-600 hover:underline"
                  >
                    admin@cruze.asia
                  </a>
                  .
                </p>
              </li>
            </ol>
          </div>
        </div>
      </section>
    </main>
  );
};

export default TermsAndConditions;
